// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4286":"078dd7b1","7867":"2dd489f6","8226":"3247096a","8390":"cc16bd72"}[chunkId] + ".chunk.css";
};